export function errorModal(err) {
  this.$store.dispatch("serverError", err.response)
  this.$mainDialog.show("report-error-modal")  
}

